import error from "common/managers/error";
export default {
    errorInit: function(config) {
        var me = this;
        if (config.localErrors === true) {
            this.bind("error", function(e) {
                error.suppressMessages(e);
                error.receiveErrors(e, me);
            });
        } else {
            this.bind("error", function(e) {
                error.receiveErrors(e, me);
            });
        }
    }
};